export default {
  refunded: {
    en: 'Refunded',
  },
}
